
					<div class="row">
              <div class="col col-login mx-auto">
                <div class="text-center mb-6">
                  <img src="assets/images/brand/logo.png" class="h-6" alt="">
                </div>
                <form class="card"  method="post">
                  <div class="card-body p-6">
                    <div class="card-title text-center">Create New Account</div>
                    <div class="form-group">
                      <label class="form-label">Name</label>
                      <input type="text" class="form-control" placeholder="Enter name">
                    </div>
                    <div class="form-group">
                      <label class="form-label">Email address</label>
                      <input type="email" class="form-control" placeholder="Enter email">
                    </div>
                    <div class="form-group">
                      <label class="form-label">Password</label>
                      <input type="password" class="form-control" placeholder="Password">
                    </div>
                    <div class="form-group">
                      <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" />
                        <span class="custom-control-label">Agree the <a  [routerLink]="[ '/' ]">terms and policy</a></span>
                      </label>
                    </div>
                    <div class="form-footer">
                      <button type="submit" class="btn btn-primary btn-block">Create new account</button>
                    </div>
                    <div class="text-center text-muted mt-4">
                    Already have account? <a [routerLink]="[ '/account/login' ]">Sign in</a>
                  </div>
                  </div>
  
                </form>
              </div>
            </div>
          